/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/currency_codes';
import './session';
import '../../cashoauth/apiProto/scope';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "grantly": {
            "nested": {
              "api": {
                "nested": {
                  "Action": {
                    "fields": {
                      "type": {
                        "type": ".squareup.cash.grantly.api.Action.Type",
                        "id": 1,
                        "rule": "optional"
                      },
                      "oneTimePayment": {
                        "type": ".squareup.cash.grantly.api.Action.OneTimePayment",
                        "id": 2
                      },
                      "onFilePayment": {
                        "type": ".squareup.cash.grantly.api.Action.OnFilePayment",
                        "id": 3
                      },
                      "unlinkedRefund": {
                        "type": ".squareup.cash.grantly.api.Action.UnlinkedRefund",
                        "id": 4
                      },
                      "linkAccount": {
                        "type": ".squareup.cash.grantly.api.Action.LinkAccount",
                        "id": 5
                      },
                      "sessionAuthentication": {
                        "type": ".squareup.cash.grantly.api.Action.SessionAuthentication",
                        "id": 6
                      },
                      "recurringDeposits": {
                        "type": ".squareup.cash.grantly.api.Action.RecurringDeposits",
                        "id": 7
                      },
                      "onFileDeposit": {
                        "type": ".squareup.cash.grantly.api.Action.OnFileDeposit",
                        "id": 8
                      },
                      "shadowAccount": {
                        "type": ".squareup.cash.grantly.api.Action.ShadowAccount",
                        "id": 9
                      },
                      "oauthReadTransaction": {
                        "type": ".squareup.cash.grantly.api.Action.OAuthReadTransactions",
                        "id": 10
                      },
                      "linkAccountTidal": {
                        "type": ".squareup.cash.grantly.api.Action.LinkAccountTidal",
                        "id": 11
                      },
                      "customerProfileSharing": {
                        "type": ".squareup.cash.grantly.api.Action.CustomerProfileSharing",
                        "id": 12
                      },
                      "oauth": {
                        "type": ".squareup.cash.grantly.api.Action.OAuth",
                        "id": 13
                      },
                      "shadowAccountAppLogin": {
                        "type": ".squareup.cash.grantly.api.Action.ShadowAccountAppLogin",
                        "id": 14
                      },
                      "onFilePayout": {
                        "type": ".squareup.cash.grantly.api.Action.OnFilePayout",
                        "id": 15
                      },
                      "openid": {
                        "type": ".squareup.cash.grantly.api.Action.OpenID",
                        "id": 16
                      }
                    },
                    "nested": {
                      "Type": {
                        "values": {
                          "ONE_TIME_PAYMENT": 1,
                          "ON_FILE_PAYMENT": 2,
                          "UNLINKED_REFUND": 3,
                          "LINK_ACCOUNT": 4,
                          "SESSION_AUTHENTICATION": 5,
                          "RECURRING_DEPOSITS": 6,
                          "ON_FILE_DEPOSIT": 7,
                          "SHADOW_ACCOUNT": 8,
                          "OAUTH_READ_TRANSACTIONS": 9,
                          "LINK_ACCOUNT_TIDAL": 10,
                          "CUSTOMER_PROFILE_SHARING": 11,
                          "OAUTH": 12,
                          "SHADOW_ACCOUNT_APP_LOGIN": 13,
                          "ON_FILE_PAYOUT": 14,
                          "OPENID": 15
                        }
                      },
                      "OneTimePayment": {
                        "fields": {
                          "amount": {
                            "type": "uint64",
                            "id": 1,
                            "rule": "optional"
                          },
                          "currency": {
                            "type": ".squareup.common.CurrencyCode",
                            "id": 2,
                            "rule": "optional"
                          },
                          "scopeId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "orderId": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "checkoutOptions": {
                            "type": ".squareup.cash.grantly.api.Action.OneTimePayment.CheckoutOptions",
                            "id": 6,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "CheckoutOptions": {
                            "fields": {
                              "automaticDiscounts": {
                                "type": "bool",
                                "id": 1,
                                "rule": "optional"
                              },
                              "scopeOptions": {
                                "type": ".squareup.cash.grantly.api.Action.ScopeOptions",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "OnFilePayment": {
                        "fields": {
                          "scopeId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "accountReferenceId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "context": {
                            "type": ".squareup.cash.grantly.api.Action.OnFilePayment.Context",
                            "id": 3,
                            "rule": "optional"
                          },
                          "checkoutOptions": {
                            "type": ".squareup.cash.grantly.api.Action.OnFilePayment.CheckoutOptions",
                            "id": 4,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Context": {
                            "fields": {
                              "orderId": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "CheckoutOptions": {
                            "fields": {
                              "scopeOptions": {
                                "type": ".squareup.cash.grantly.api.Action.ScopeOptions",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "UnlinkedRefund": {
                        "fields": {
                          "amount": {
                            "type": "uint64",
                            "id": 1,
                            "rule": "optional"
                          },
                          "currency": {
                            "type": ".squareup.common.CurrencyCode",
                            "id": 2,
                            "rule": "optional"
                          },
                          "scopeId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "LinkAccount": {
                        "fields": {
                          "primaryAlias": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "secondaryAlias": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "SessionAuthentication": {
                        "fields": {
                          "scopes": {
                            "type": ".squareup.cash.grantly.api.SessionScope",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "associatedRequestId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "associatedRedirectUrl": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "associatedClientId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "RecurringDeposits": {
                        "fields": {
                          "primaryAlias": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "logoUrl": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "accountReferenceId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "OnFileDeposit": {
                        "fields": {
                          "scopeId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "accountReferenceId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "OnFilePayout": {
                        "fields": {
                          "scopeId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "accountReferenceId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ShadowAccount": {
                        "fields": {}
                      },
                      "ShadowAccountAppLogin": {
                        "fields": {}
                      },
                      "OAuthReadTransactions": {
                        "fields": {}
                      },
                      "LinkAccountTidal": {
                        "fields": {
                          "accountReferenceId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "preVerify": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CustomerProfileSharing": {
                        "fields": {
                          "scopeId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ScopeOptions": {
                        "fields": {
                          "risky": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "OAuth": {
                        "fields": {
                          "permissions": {
                            "type": ".squareup.cash.grantly.api.Action.OAuth.Permission",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "metadata": {
                            "type": ".squareup.cash.grantly.api.Action.OAuth.Metadata",
                            "id": 2,
                            "rule": "optional"
                          },
                          "scopesRequested": {
                            "type": ".squareup.cash.cashoauth.apiProto.Scope",
                            "id": 3,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "Permission": {
                            "values": {
                              "CUSTOMER_CASHTAG_READ": 1,
                              "ACCOUNT_BAL_READ": 2
                            }
                          },
                          "Metadata": {
                            "fields": {
                              "type": {
                                "type": ".squareup.cash.grantly.api.Action.OAuth.Metadata.Type",
                                "id": 1,
                                "rule": "optional"
                              },
                              "financialDataSharing": {
                                "type": ".squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing",
                                "id": 2
                              }
                            },
                            "nested": {
                              "Type": {
                                "values": {
                                  "FINANCIAL_DATA_SHARING": 1
                                }
                              },
                              "FinancialDataSharing": {
                                "fields": {
                                  "authorizedAccountTypes": {
                                    "type": ".squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "dataRecipient": {
                                    "type": ".squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing.DataRecipient",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "intermediaries": {
                                    "type": ".squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing.Intermediary",
                                    "id": 3,
                                    "rule": "repeated"
                                  }
                                },
                                "nested": {
                                  "AuthorizedAccountTypes": {
                                    "fields": {
                                      "type": {
                                        "type": ".squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.Type",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "allAccountTypes": {
                                        "type": ".squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.AllAccountTypes",
                                        "id": 2
                                      },
                                      "limitedAccountTypes": {
                                        "type": ".squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.LimitedAccountTypes",
                                        "id": 3
                                      }
                                    },
                                    "nested": {
                                      "Type": {
                                        "values": {
                                          "ALL_ACCOUNT_TYPES": 1,
                                          "LIMITED_ACCOUNT_TYPES": 2
                                        }
                                      },
                                      "AllAccountTypes": {
                                        "fields": {}
                                      },
                                      "LimitedAccountTypes": {
                                        "fields": {
                                          "accountTypes": {
                                            "type": ".squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.AccountType",
                                            "id": 2,
                                            "rule": "repeated"
                                          }
                                        }
                                      },
                                      "AccountType": {
                                        "values": {
                                          "SVB": 1,
                                          "SAVINGS": 2,
                                          "BNPL": 3
                                        }
                                      },
                                      "authorized_account_types": {
                                        "oneof": ["allAccountTypes", "limitedAccountTypes"]
                                      }
                                    }
                                  },
                                  "DataRecipient": {
                                    "fields": {
                                      "clientId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                      }
                                    }
                                  },
                                  "Intermediary": {
                                    "fields": {
                                      "intermediaryId": {
                                        "type": "string",
                                        "id": 1,
                                        "rule": "optional"
                                      }
                                    }
                                  }
                                }
                              },
                              "metadata": {
                                "oneof": ["financialDataSharing"]
                              }
                            }
                          }
                        }
                      },
                      "OpenID": {
                        "fields": {}
                      },
                      "details": {
                        "oneof": ["oneTimePayment", "onFilePayment", "unlinkedRefund", "linkAccount", "sessionAuthentication", "recurringDeposits", "onFileDeposit", "shadowAccount", "oauthReadTransaction", "linkAccountTidal", "customerProfileSharing", "oauth", "shadowAccountAppLogin", "onFilePayout", "openid"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.Type && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OneTimePayment && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OneTimePayment?.nested?.CheckoutOptions && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OnFilePayment && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OnFilePayment?.nested?.Context && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OnFilePayment?.nested?.CheckoutOptions && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.UnlinkedRefund && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.LinkAccount && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.SessionAuthentication && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.RecurringDeposits && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OnFileDeposit && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OnFilePayout && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.ShadowAccount && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.ShadowAccountAppLogin && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OAuthReadTransactions && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.LinkAccountTidal && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.CustomerProfileSharing && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.ScopeOptions && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OAuth && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OAuth?.nested?.Permission && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OAuth?.nested?.Metadata && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OAuth?.nested?.Metadata?.nested?.Type && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OAuth?.nested?.Metadata?.nested?.FinancialDataSharing && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OAuth?.nested?.Metadata?.nested?.FinancialDataSharing?.nested?.AuthorizedAccountTypes && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OAuth?.nested?.Metadata?.nested?.FinancialDataSharing?.nested?.AuthorizedAccountTypes?.nested?.Type && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OAuth?.nested?.Metadata?.nested?.FinancialDataSharing?.nested?.AuthorizedAccountTypes?.nested?.AllAccountTypes && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OAuth?.nested?.Metadata?.nested?.FinancialDataSharing?.nested?.AuthorizedAccountTypes?.nested?.LimitedAccountTypes && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OAuth?.nested?.Metadata?.nested?.FinancialDataSharing?.nested?.AuthorizedAccountTypes?.nested?.AccountType && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OAuth?.nested?.Metadata?.nested?.FinancialDataSharing?.nested?.DataRecipient && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OAuth?.nested?.Metadata?.nested?.FinancialDataSharing?.nested?.Intermediary && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Action?.nested?.OpenID) {
  $root.addJSON(jsonData);
}

/**
 * Represents an intent from a third-party client to perform the contained
 * operation.
 *
 * SOURCE Action @ squareup/cash/grantly/api/action.proto at 15:1
 */
export const Action = $root.lookupType('squareup.cash.grantly.api.Action');
fixType(Action);
Builder.createAndAttachToType(Action);
/**
 * ///////////////////////////////////////////////////////////////////////////
 * ALL ACTION TYPE DATA GOES BELOW THIS LINE
 * Represents the type of action and what details are contained in the action
 * payload.
 *
 * SOURCE Type @ squareup/cash/grantly/api/action.proto at 115:3
 */
Action.Type = $root.lookupEnum('squareup.cash.grantly.api.Action.Type').values;
/**
 * Represents an intent for a third-party to charge a Cash customer on behalf
 * of a merchant.
 *
 * - Associated with `ONE_TIME` use grants.
 *
 * SOURCE OneTimePayment @ squareup/cash/grantly/api/action.proto at 200:3
 */
Action.OneTimePayment = $root.lookupType('squareup.cash.grantly.api.Action.OneTimePayment');
fixType(Action.OneTimePayment);
Builder.createAndAttachToType(Action.OneTimePayment);
/**
 * Next ID: 7
 * Describes the different options partners can configure while a customer is checking out with Cash App Pay.
 *
 * SOURCE CheckoutOptions @ squareup/cash/grantly/api/action.proto at 251:5
 */
Action.OneTimePayment.CheckoutOptions = $root.lookupType('squareup.cash.grantly.api.Action.OneTimePayment.CheckoutOptions');
fixType(Action.OneTimePayment.CheckoutOptions);
Builder.createAndAttachToType(Action.OneTimePayment.CheckoutOptions);
/**
 * Represents an intent for a third-party to repeatedly charge or refund a
 * Cash customer on behalf of a merchant.
 *
 * - Associated with `EXTENDED` use grants.
 *
 * SOURCE OnFilePayment @ squareup/cash/grantly/api/action.proto at 270:3
 */
Action.OnFilePayment = $root.lookupType('squareup.cash.grantly.api.Action.OnFilePayment');
fixType(Action.OnFilePayment);
Builder.createAndAttachToType(Action.OnFilePayment);
/**
 * Data that will not be persisted onto the grant,
 * but used for enhanced UX purposes within the request approval flow.
 * These enhancements could include: order amounts/totals, shipping information, order details.
 *
 * SOURCE Context @ squareup/cash/grantly/api/action.proto at 301:5
 */
Action.OnFilePayment.Context = $root.lookupType('squareup.cash.grantly.api.Action.OnFilePayment.Context');
fixType(Action.OnFilePayment.Context);
Builder.createAndAttachToType(Action.OnFilePayment.Context);
/**
 * Describes the different options partners can configure while a customer is checking out with Cash App Pay.
 *
 * SOURCE CheckoutOptions @ squareup/cash/grantly/api/action.proto at 317:5
 */
Action.OnFilePayment.CheckoutOptions = $root.lookupType('squareup.cash.grantly.api.Action.OnFilePayment.CheckoutOptions');
fixType(Action.OnFilePayment.CheckoutOptions);
Builder.createAndAttachToType(Action.OnFilePayment.CheckoutOptions);
/**
 * Represents an intent for a third-party to issue an unlinked refund to a
 * Cash customer on behalf of a merchant.
 *
 * - Associated with `ONE_TIME` use grants.
 *
 * SOURCE UnlinkedRefund @ squareup/cash/grantly/api/action.proto at 333:3
 */
Action.UnlinkedRefund = $root.lookupType('squareup.cash.grantly.api.Action.UnlinkedRefund');
fixType(Action.UnlinkedRefund);
Builder.createAndAttachToType(Action.UnlinkedRefund);
/**
 * SOURCE LinkAccount @ squareup/cash/grantly/api/action.proto at 371:3
 */
Action.LinkAccount = $root.lookupType('squareup.cash.grantly.api.Action.LinkAccount');
fixType(Action.LinkAccount);
Builder.createAndAttachToType(Action.LinkAccount);
/**
 * SOURCE SessionAuthentication @ squareup/cash/grantly/api/action.proto at 393:3
 */
Action.SessionAuthentication = $root.lookupType('squareup.cash.grantly.api.Action.SessionAuthentication');
fixType(Action.SessionAuthentication);
Builder.createAndAttachToType(Action.SessionAuthentication);
/**
 * SOURCE RecurringDeposits @ squareup/cash/grantly/api/action.proto at 421:3
 */
Action.RecurringDeposits = $root.lookupType('squareup.cash.grantly.api.Action.RecurringDeposits');
fixType(Action.RecurringDeposits);
Builder.createAndAttachToType(Action.RecurringDeposits);
/**
 * SOURCE OnFileDeposit @ squareup/cash/grantly/api/action.proto at 450:3
 */
Action.OnFileDeposit = $root.lookupType('squareup.cash.grantly.api.Action.OnFileDeposit');
fixType(Action.OnFileDeposit);
Builder.createAndAttachToType(Action.OnFileDeposit);
/**
 * Represents an intent for a third-party to repeatedly payout to a
 * Cash customer.
 *
 * - Associated with `EXTENDED` use grants.
 *
 * SOURCE OnFilePayout @ squareup/cash/grantly/api/action.proto at 482:3
 */
Action.OnFilePayout = $root.lookupType('squareup.cash.grantly.api.Action.OnFilePayout');
fixType(Action.OnFilePayout);
Builder.createAndAttachToType(Action.OnFilePayout);
/**
 * Represents the intent to create and maintain a shadow or cash-app managed account
 *  on Afterpay.
 *
 * SOURCE ShadowAccount @ squareup/cash/grantly/api/action.proto at 512:3
 */
Action.ShadowAccount = $root.lookupType('squareup.cash.grantly.api.Action.ShadowAccount');
fixType(Action.ShadowAccount);
Builder.createAndAttachToType(Action.ShadowAccount);
/**
 * Represents the intent for a shadow or cash-app managed account to log into the Afterpay app
 *
 * SOURCE ShadowAccountAppLogin @ squareup/cash/grantly/api/action.proto at 519:3
 */
Action.ShadowAccountAppLogin = $root.lookupType('squareup.cash.grantly.api.Action.ShadowAccountAppLogin');
fixType(Action.ShadowAccountAppLogin);
Builder.createAndAttachToType(Action.ShadowAccountAppLogin);
/**
 * OAuth Scope for reading a customer's transactions.
 *
 * SOURCE OAuthReadTransactions @ squareup/cash/grantly/api/action.proto at 526:3
 */
Action.OAuthReadTransactions = $root.lookupType('squareup.cash.grantly.api.Action.OAuthReadTransactions');
fixType(Action.OAuthReadTransactions);
Builder.createAndAttachToType(Action.OAuthReadTransactions);
/**
 * Represents the intent to link a Cash customers account to TIDAL
 *
 * SOURCE LinkAccountTidal @ squareup/cash/grantly/api/action.proto at 533:3
 */
Action.LinkAccountTidal = $root.lookupType('squareup.cash.grantly.api.Action.LinkAccountTidal');
fixType(Action.LinkAccountTidal);
Builder.createAndAttachToType(Action.LinkAccountTidal);
/**
 * Represents the intent to share protected and sensitive customer data with a third-party.
 *
 * SOURCE CustomerProfileSharing @ squareup/cash/grantly/api/action.proto at 558:3
 */
Action.CustomerProfileSharing = $root.lookupType('squareup.cash.grantly.api.Action.CustomerProfileSharing');
fixType(Action.CustomerProfileSharing);
Builder.createAndAttachToType(Action.CustomerProfileSharing);
/**
 * SOURCE ScopeOptions @ squareup/cash/grantly/api/action.proto at 579:3
 */
Action.ScopeOptions = $root.lookupType('squareup.cash.grantly.api.Action.ScopeOptions');
fixType(Action.ScopeOptions);
Builder.createAndAttachToType(Action.ScopeOptions);
/**
 * Represents an OAuth authorization intent, including requested permissions,
 * and any associated metadata.
 *
 * SOURCE OAuth @ squareup/cash/grantly/api/action.proto at 591:3
 */
Action.OAuth = $root.lookupType('squareup.cash.grantly.api.Action.OAuth');
fixType(Action.OAuth);
Builder.createAndAttachToType(Action.OAuth);
/**
 * * **DEPRECATED **
 * - Granular permissions are no longer necessary for OAuth (proposal)[https://docs.google.com/document/d/1eiMkhyqEBVa-GpUEDvdtrINIYBv2Obrg5BP1CGlw614/edit?tab=t.0#heading=h.yx7mu5quk2oq]
 * - If granular permissions are needed in the future, use [Permission](https://github.com/squareup/cash-server/blob/main/sessions/protos/src/main/proto/squareup/cash/sessions/service.proto)
 * Internal permission enum used to describe third-party data access privileges.
 *
 * SOURCE Permission @ squareup/cash/grantly/api/action.proto at 598:5
 */
Action.OAuth.Permission = $root.lookupEnum('squareup.cash.grantly.api.Action.OAuth.Permission').values;
/**
 * Metadata describing the context or intent associated with the OAuth action.
 *
 * SOURCE Metadata @ squareup/cash/grantly/api/action.proto at 627:5
 */
Action.OAuth.Metadata = $root.lookupType('squareup.cash.grantly.api.Action.OAuth.Metadata');
fixType(Action.OAuth.Metadata);
Builder.createAndAttachToType(Action.OAuth.Metadata);
/**
 * SOURCE Type @ squareup/cash/grantly/api/action.proto at 634:7
 */
Action.OAuth.Metadata.Type = $root.lookupEnum('squareup.cash.grantly.api.Action.OAuth.Metadata.Type').values;
/**
 * Contains parameters describing the scope and participants
 * involved in financial data sharing via OAuth.
 *
 * SOURCE FinancialDataSharing @ squareup/cash/grantly/api/action.proto at 651:7
 */
Action.OAuth.Metadata.FinancialDataSharing = $root.lookupType('squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing');
fixType(Action.OAuth.Metadata.FinancialDataSharing);
Builder.createAndAttachToType(Action.OAuth.Metadata.FinancialDataSharing);
/**
 * Defines the set of account types for which access is being granted.
 * Access can be granted to ALL account types, or limited to a specific selection.
 *
 * SOURCE AuthorizedAccountTypes @ squareup/cash/grantly/api/action.proto at 673:9
 */
Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes = $root.lookupType('squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes');
fixType(Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes);
Builder.createAndAttachToType(Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes);
/**
 * SOURCE Type @ squareup/cash/grantly/api/action.proto at 679:11
 */
Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.Type = $root.lookupEnum('squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.Type').values;
/**
 * Placeholder type for "all accounts"; intentionally left empty.
 *
 * SOURCE AllAccountTypes @ squareup/cash/grantly/api/action.proto at 704:11
 */
Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.AllAccountTypes = $root.lookupType('squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.AllAccountTypes');
fixType(Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.AllAccountTypes);
Builder.createAndAttachToType(Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.AllAccountTypes);
/**
 * Lists specific account types being granted access.
 *
 * SOURCE LimitedAccountTypes @ squareup/cash/grantly/api/action.proto at 709:11
 */
Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.LimitedAccountTypes = $root.lookupType('squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.LimitedAccountTypes');
fixType(Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.LimitedAccountTypes);
Builder.createAndAttachToType(Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.LimitedAccountTypes);
/**
 * Account types that can be shared.
 *
 * SOURCE AccountType @ squareup/cash/grantly/api/action.proto at 721:11
 */
Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.AccountType = $root.lookupEnum('squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing.AuthorizedAccountTypes.AccountType').values;
/**
 * Information about the data recipient (end beneficiary of data access).
 *
 * SOURCE DataRecipient @ squareup/cash/grantly/api/action.proto at 731:9
 */
Action.OAuth.Metadata.FinancialDataSharing.DataRecipient = $root.lookupType('squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing.DataRecipient');
fixType(Action.OAuth.Metadata.FinancialDataSharing.DataRecipient);
Builder.createAndAttachToType(Action.OAuth.Metadata.FinancialDataSharing.DataRecipient);
/**
 * Information about an intermediary involved in the data sharing flow.
 *
 * SOURCE Intermediary @ squareup/cash/grantly/api/action.proto at 742:9
 */
Action.OAuth.Metadata.FinancialDataSharing.Intermediary = $root.lookupType('squareup.cash.grantly.api.Action.OAuth.Metadata.FinancialDataSharing.Intermediary');
fixType(Action.OAuth.Metadata.FinancialDataSharing.Intermediary);
Builder.createAndAttachToType(Action.OAuth.Metadata.FinancialDataSharing.Intermediary);
/**
 * Represents an OpenID Connect authentication request.
 *
 * SOURCE OpenID @ squareup/cash/grantly/api/action.proto at 770:3
 */
Action.OpenID = $root.lookupType('squareup.cash.grantly.api.Action.OpenID');
fixType(Action.OpenID);
Builder.createAndAttachToType(Action.OpenID);